export default __webpack_public_path__ + "static/media/IFY_Magicbricks_Logo.11b354f2.png";